module.exports = __webpack_public_path__ + "static/media/notes_intro_folder.0f1f4550.png";